import { useBanderoleQuery } from '@contentfulTypes'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { DEFAULT_LOCALE } from '~/config/constants'
import { createGraphQLClient } from '~/graphql/contentfulClient'
import { usePreviewMode } from '~/hooks/usePreviewMode'
import { createLanguageRegionLocale } from '~/lib/createLanguageRegionLocale'
import clsx from 'clsx'
import Copy from '~/modules/Header/components/Icons/Copy'
import useCountdownData from '~/hooks/useCountdownData'
import BanderoleCountdown from '~/modules/Banderole/components/BanderoleCountdown'

type Props = {
  className?: string
}

export const Promo = ({ className }: Props) => {
  const router = useRouter()
  const preview = usePreviewMode()
  const contentfulClient = createGraphQLClient({ preview })
  const { data: banderoleData } = useBanderoleQuery(contentfulClient, {
    preview,
    locale: router.locale ? createLanguageRegionLocale(router.locale) : DEFAULT_LOCALE,
  })
  const { t } = useTranslation()

  const [isPromoCodeCopied, setisPromoCodeCopied] = useState(false)

  const countdownData = useCountdownData({
    isBanderoleVisible:
      banderoleData?.pageCollection?.items[0]?.banderole?.countDown?.countDownDate &&
      !banderoleData?.pageCollection?.items[0]?.banderole?.countDown?.hidePdpCountdown,
    banderoleData: banderoleData?.pageCollection?.items[0]?.banderole?.countDown?.countDownDate,
    rerenderCondition: banderoleData?.pageCollection?.items,
  })

  const copyToClipboard = () => {
    navigator?.clipboard?.writeText(
      banderoleData?.pageCollection?.items[0]?.banderole?.countDown?.discountCode as string,
    )
    setisPromoCodeCopied(true)
  }

  if (!banderoleData?.pageCollection?.items[0]?.banderole?.countDown) return null

  return (
    <div
      className={clsx(
        className ?? '',
        'flex flex-col items-center justify-center bg-primary-pink p-3',
        countdownData.isReady || countdownData.expired ? 'min-h-[81px]' : 'min-h-[46px]',
      )}
      style={{
        background: banderoleData?.pageCollection?.items[0]?.banderole?.backgroundColor as string,
        color: banderoleData?.pageCollection?.items[0]?.banderole?.textColor as string,
      }}
    >
      <div className="flex w-full items-center justify-center ">
        <span
          className="!text-[12px] !leading-[22px]"
          dangerouslySetInnerHTML={{
            __html: banderoleData?.pageCollection?.items[0]?.banderole?.countDown
              ?.pdpText as string,
          }}
        />

        <button
          onClick={() => copyToClipboard()}
          disabled={isPromoCodeCopied}
          className="ml-1 text-center uppercase disabled:text-primary-white"
        >
          <div className="flex items-center justify-center">
            <span className="text-[12px] font-bold leading-[20px] ">
              {!isPromoCodeCopied
                ? banderoleData?.pageCollection?.items[0]?.banderole?.countDown?.discountCode
                : t('CODE COPYED')}
            </span>
            {!isPromoCodeCopied && <Copy className="ml-1 h-4 w-4" />}
          </div>
        </button>
      </div>
      {countdownData.expired && (
        <div className="mt-2 text-center text-p font-bold uppercase">{t('EXPIRED')}</div>
      )}
      {countdownData.isReady && (
        <BanderoleCountdown countdownData={countdownData} showLabel className="mt-2 min-w-full" />
      )}
    </div>
  )
}
